<template>
  <span class="loader" :class="cls" v-if="showLoader"></span>
</template>

<script>
  export default {
    name: 'loader',
    cls: '',
    data () {
      return {
        showLoader: this.show
      }
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'default'
      }
    },
    methods: {
      setType () {
        this.cls = this.type
      }
    },
    watch: {
      show () {
        if (this.show === true) {
          setTimeout(() => {
            if (this.show === true) {
              this.showLoader = true
            }
          }, 300)
        } else {
          this.showLoader = false
        }
      }
    },
    created () {
      this.setType()
    }
  }
</script>

<style lang="scss" type="text/scss">
  .loader {
    display: inline-block;
    width: 0;
    height: 16px;
    position: relative;
    transition: width .3s;
    &::after {
      content: '';
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      animation: loader;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }
    &.default {
      width: 16px;
    }
    &.button {
      width: 16px;
      margin-left: 15px;
      top: 2px;
    }
    &.cover {
      position: absolute;
      z-index: 999;
      display: block;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .2);
      width: 100%;
      height: 100%;
      &::after {
        top: calc(50% - 16px);
        left: calc(50% - 16px);
        width: 32px;
        height: 32px;
      }
    }
  }

  @keyframes loader {
    0% {
      transform: rotateY(0deg);
      background-color: rgba(255, 255, 255, 1);
    }
    50% {
      background-color: rgba(255, 255, 255, .3);
    }
    100% {
      transform: rotateY(180deg);
      background-color: rgba(255, 255, 255, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// Loader.vue?8881efe4